<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="text-center azul--text pt-5 mt-5">
                <h2>
                    {{ title }}
                </h2>
            </v-col>
        </v-row>
        <v-layout justify-center wrap>
            <v-flex md4 sm6 xs12>
                <v-card elevation="0">
                    <v-card-text>
                        <v-list disabled>
                            <v-list-item-group>
                                <v-list-item
                                    v-for="(item, i) in contactInfo"
                                    :key="i"
                                >
                                    <div
                                        v-for="(icon, j) in item.icon"
                                        :key="j"
                                    >
                                        <v-list-item-icon>
                                            <v-icon
                                                color="azul"
                                                v-text="icon"
                                            />
                                        </v-list-item-icon>
                                    </div>
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="azul--text"
                                            v-text="item.text"
                                        />
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.9494234551953!2d-60.7591726846395!3d-32.92593447817055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b6529a0fe4562b%3A0xfd06efdca2aa5c5c!2sDroguer%C3%ADa%20Ciafarma!5e0!3m2!1sen!2sar!4v1591103445256!5m2!1sen!2sar"
                            width="100%"
                            height="300"
                            frameborder="0"
                            style="border: 0;"
                            allowfullscreen=""
                            aria-hidden="false"
                            tabindex="0"
                        />
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex md4 sm12 xs12>
                <v-card elevation="0">
                    <v-card-title class="azul--text">
                        <h3>
                            <strong>
                                Crear una cuenta
                            </strong>
                        </h3>
                    </v-card-title>
                    <v-card-text class="azul--text my-0 py-0">
                        <h3>
                            {{ helpText }}
                        </h3>
                    </v-card-text>
                    <CardForm
                        :reset="reset"
                        transparent
                        hide-divider
                        hide-header
                    >
                        <template
                            v-slot:default="{
                                rules
                            }"
                        >
                            <v-text-field
                                v-model.lazy="name"
                                label="Nombre"
                                validate-on-blur
                                :rules="[rules.required()]"
                            />
                            <v-text-field
                                v-model.lazy="email"
                                label="Correo Electrónico"
                                validate-on-blur
                                :rules="[rules.required(), rules.email()]"
                            />
                            <v-text-field
                                v-model.lazy="message"
                                label="Mensaje"
                                validate-on-blur
                                :rules="[rules.required()]"
                            />
                            <v-file-input
                                v-model="file1"
                                :rules="fileRule"
                                accept="application/pdf,application/msword,image/jpeg"
                                label="Comprobante CUIT"
                            />
                            <v-file-input
                                v-model="file2"
                                :rules="fileRule"
                                accept="application/pdf,application/msword,image/jpeg"
                                label="Habilitación salud pública"
                            />
                        </template>
                        <template slot="message">
                            <p v-show="error" class="error--text show-error">
                                {{ error }}
                            </p>
                        </template>
                        <template slot="actions">
                            <v-btn
                                color="azul"
                                dark
                                type="submit"
                                @click="sendEmail"
                            >
                                Enviar
                            </v-btn>
                        </template>
                    </CardForm>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="successDialog" max-width="400">
            <v-card>
                <v-card-title class="headline mb-0">
                    Mensaje Enviado
                </v-card-title>
                <v-card-text class="pt-0">
                    <p class="mt-0 mb-2">
                        Su mensaje fue enviado con éxito
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="successDialog = false">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import CardForm from '../components/CardForm';
import { contactData } from '../utils';
import axios from '../utils/axios';
import { mapState } from 'vuex';

export default {
    components: { CardForm },

    data: () => ({
        reset: false,
        name: '',
        email: '',
        web: '',
        message: '',
        error: '',
        file1: null,
        file2: null,
        fileRule: [
            value =>
                !value ||
                value.size < 25 * 1024 * 1024 ||
                'El archivo debe pesar menos de ' + 25 + ' MB!' //cambiar por el valor que sea
        ],
        successDialog: false,
        title: 'Si tiene alguna consulta, no dude en contactarnos !',
        helpText:
            'En caso de estar solicitando una cuenta, por favor adjunte tanto el comprobante de C.U.I.T como la habilitación de salud pública'
    }),

    computed: {
        ...mapState(['token']),
        contactInfo() {
            return [
                {
                    icon: ['phone_iphone', 'mdi-whatsapp'],
                    text: contactData.cellphone
                },
                {
                    icon: ['location_on'],
                    text: contactData.direccion
                },
                {
                    icon: ['email'],
                    text: contactData.email
                }
            ];
        }
    },

    methods: {
        resetForm() {
            this.name = '';
            this.email = '';
            this.web = '';
            this.message = '';
            this.file1 = null;
            this.file2 = null;
            this.reset = !this.reset;
        },
        async sendEmail(formValid) {
            if (!formValid) {
                return;
            }
            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('email', this.email);
            formData.append('web', this.web);
            formData.append('message', this.message);
            formData.append('file1', this.file1);
            formData.append('file2', this.file2);
            const { data, error } = await axios({
                url: './contacto/sendEmail',
                method: 'POST',
                data: formData,
                headers: {
                    Accept: 'application/json',
                    authorization: this.token,
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (error) {
                this.error = 'Algo salió mal';
            }
            if (data.status === 400) {
                this.error = 'No se pudo enviar el email';
            } else {
                this.successDialog = true;
                this.resetForm();
            }
        }
    }
};
</script>
